import React from 'react';
import { connect } from 'react-redux';
import NbReclamationsCreeesIndicateur from './NbReclamationsCreeesIndicateur';
import { fetchReclamationsCreeesIfNeeded } from 'store/reclamation/indicateursActions';

import { resetRechercheCriteres } from 'store/reclamation/reclamationsActions';
import { updateRechercheCriteres } from 'store/reclamation/reclamationsActions';


import { clearFournisseurValue } from 'store/fournisseur/fournisseurActions';
import { clearTransporteurValue } from 'store/transporteur/transporteurActions';
import { clearClientValue } from 'store/client/clientActions';
import { clearSuggestionsArticleGestion } from 'store/articleGestion/articlesGestionActions';
import { clearAgenceValue } from 'store/agence/agenceActions';
import { clearUtilisateurValue } from 'store/utilisateur/utilisateursActions';


import { ReclamationFiltre } from '../../../../../constants';

class NbReclamationsCreeesIndicateurContainer extends React.Component {

    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    componentDidMount() {
        this.props.fetchReclamationsCreeesIfNeeded();
    }


    componentDidUpdate(prevProps) {
        if (this.props.didInvalidate && !prevProps.didInvalidate) {
            this.props.fetchReclamationsCreeesIfNeeded();
        }
    }


    handleClick() {
        let date = new Date();
        let month = date.getMonth() + 1;
        let day = date.getDate();

        
        this.props.resetRechercheCriteres();
        this.props.clearFournisseurValue("searchFilters");
        this.props.clearTransporteurValue("searchFilters");
        this.props.clearClientValue("searchFilters");
        this.props.clearSuggestionsArticleGestion("searchFilters");
        this.props.clearAgenceValue();

        this.props.clearUtilisateurValue("searchFiltersUtilisateur");
        this.props.clearUtilisateurValue("searchFiltersEmetteur");
        this.props.clearUtilisateurValue("searchFiltersUtilisateurPreneurOrdre");
        this.props.clearUtilisateurValue("searchFiltersObservateur");
        

        this.props.updateRechercheCriteres({
            filtre: ReclamationFiltre.Toutes,
            dateCreationDebut: `${date.getFullYear()}-${(month < 10 ? '0' : '')}${month}-${(day < 10 ? '0' : '')}${day}`
        });
    }

    render() {
        return <NbReclamationsCreeesIndicateur isLoading={this.props.isLoading} count={this.props.valeur} onClick={this.handleClick} />;
    }
}

const mapStateToProps = state => ({
    valeur: state.reclamation.indicateurs.creees.valeur,
    isLoading: state.reclamation.indicateurs.creees.isLoading,
    didInvalidate: state.reclamation.indicateurs.creees.didInvalidate
});

const mapDispatchToProps = dispatch => ({
    fetchReclamationsCreeesIfNeeded: () => dispatch(fetchReclamationsCreeesIfNeeded()),
    updateRechercheCriteres: criteres => dispatch(updateRechercheCriteres(criteres)),
    resetRechercheCriteres: () => dispatch(resetRechercheCriteres()),

    clearFournisseurValue: (namespace) => dispatch(clearFournisseurValue(namespace)),
    clearTransporteurValue: (namespace) => dispatch(clearTransporteurValue(namespace)),
    clearClientValue: (namespace) => dispatch(clearClientValue(namespace)),
    clearSuggestionsArticleGestion: (namespace) => dispatch(clearSuggestionsArticleGestion(namespace)),
    clearUtilisateurValue: (namespace) => dispatch(clearUtilisateurValue(namespace)),
    clearAgenceValue: () => dispatch(clearAgenceValue())
});

export default connect(mapStateToProps, mapDispatchToProps)(NbReclamationsCreeesIndicateurContainer);